export const safeNavigate = (navigate, to, options) => {
  try {
    navigate(to, options);
  } catch (err) {
    if (typeof window !== 'undefined') {
      window.location.assign(to);
    } else {
      throw err;
    }
  }
};
